"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.switchPalette = exports.switchControlPalette = exports.sparklinePalette = exports.paletteForegrounds = exports.paletteBorders = exports.paletteBackgrounds = exports.overlayPalette = exports.elevation2Palette = exports.elevation2ChildrenPalette = exports.elevation1Palette = exports.elevation1ChildrenPalette = exports.defaultPaletteOverrides = exports.defaultPalette = exports.darkDefaultPalette = void 0;
/**
 * DO NOT MODIFY
 * Generated from scripts/codegen/main.ts
 */

const defaultPalette = {
  foreground: 'gray100',
  foregroundMuted: 'gray60',
  background: 'gray0',
  backgroundAlternate: 'gray5',
  backgroundOverlay: ['gray80', 0.33],
  line: ['gray60', 0.2],
  lineHeavy: ['gray60', 0.66],
  primary: 'blue60',
  primaryWash: 'blue0',
  primaryForeground: 'gray0',
  negative: 'red60',
  negativeForeground: 'gray0',
  positive: 'green60',
  positiveForeground: 'gray0',
  secondary: 'gray5',
  secondaryForeground: 'gray100',
  transparent: ['gray0', 0],
  warning: 'yellow50'
};
exports.defaultPalette = defaultPalette;
const darkDefaultPalette = {
  foreground: 'gray100',
  foregroundMuted: 'gray60',
  background: 'gray0',
  backgroundAlternate: 'gray5',
  backgroundOverlay: ['gray80', 0.33],
  line: ['gray60', 0.2],
  lineHeavy: ['gray60', 0.66],
  primary: 'blue70',
  primaryWash: 'blue0',
  primaryForeground: 'gray0',
  negative: 'red60',
  negativeForeground: 'gray0',
  positive: 'green60',
  positiveForeground: 'gray0',
  secondary: 'gray20',
  secondaryForeground: 'gray100',
  transparent: ['gray0', 0],
  warning: 'yellow50'
};
exports.darkDefaultPalette = darkDefaultPalette;
const switchPalette = {
  backgroundAlternate: 'gray20'
};
exports.switchPalette = switchPalette;
const defaultPaletteOverrides = {
  light: {},
  dark: {
    secondary: 'gray20',
    primary: 'blue70'
  }
};
exports.defaultPaletteOverrides = defaultPaletteOverrides;
const elevation1Palette = {
  dark: {
    background: 'gray5',
    transparent: 'gray5'
  }
};
exports.elevation1Palette = elevation1Palette;
const elevation1ChildrenPalette = {
  dark: {
    secondary: ['gray20', 1]
  }
};
exports.elevation1ChildrenPalette = elevation1ChildrenPalette;
const elevation2Palette = {
  dark: {
    background: 'gray10',
    transparent: 'gray10'
  }
};
exports.elevation2Palette = elevation2Palette;
const elevation2ChildrenPalette = {
  dark: {
    line: ['gray60', 0.68]
  }
};
exports.elevation2ChildrenPalette = elevation2ChildrenPalette;
const overlayPalette = {
  light: {
    backgroundOverlay: ['gray80', 0.33]
  },
  dark: {
    backgroundOverlay: ['gray0', 0.5]
  }
};
exports.overlayPalette = overlayPalette;
const sparklinePalette = {
  line: 'gray20'
};
exports.sparklinePalette = sparklinePalette;
const switchControlPalette = {
  light: {
    background: 'gray0',
    backgroundAlternate: 'gray20'
  },
  dark: {
    background: 'gray100',
    backgroundAlternate: 'gray20'
  }
};
exports.switchControlPalette = switchControlPalette;
const paletteForegrounds = ['foreground', 'foregroundMuted', 'primary', 'primaryForeground', 'secondary', 'secondaryForeground', 'positive', 'positiveForeground', 'negative', 'negativeForeground', 'warning'];
exports.paletteForegrounds = paletteForegrounds;
const paletteBackgrounds = ['background', 'backgroundAlternate', 'backgroundOverlay', 'primary', 'primaryWash', 'secondary', 'positive', 'negative', 'transparent', 'warning'];
exports.paletteBackgrounds = paletteBackgrounds;
const paletteBorders = ['primary', 'primaryWash', 'secondary', 'positive', 'negative', 'line', 'lineHeavy', 'transparent', 'warning'];
exports.paletteBorders = paletteBorders;